import { createContext } from "react";

export const ProfileVerifierContext = createContext();
